import {connect} from 'react-redux'
import UserViewEdit from "../../Components/Toolbars/TopToolbar/UsersDialog/UserViewEdit/UserViewEdit";
import * as usersActions from "../actions/usersActions";

const connectAndForwardRef = (
    mapStateToProps = null,
    mapDispatchToProps = null,
    mergeProps = null,
    options = {},
) => component => connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
    {
        ...options,
        forwardRef: true,
    },
)(component);

const mapStateToProps = (store) => {
    return {
        profiles: store.profilesReducer.profiles,
        business: store.businessReducer.business
    };
};

const mapDispatchToProps = {
    addUser: usersActions.addUserAction,
    editUser: usersActions.editUserAction,
    deleteUser: usersActions.deleteUserAction
};

const UserViewContainer = connectAndForwardRef(mapStateToProps, mapDispatchToProps)(UserViewEdit);

export default UserViewContainer;